"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.regionRouter = exports.composeRegion = exports.RegionRouter = void 0;
const React = __importStar(require("react"));
const registry_1 = require("./registry");
const topoSortByDependsOn = (ops) => {
    var _a, _b;
    if (ops.length <= 1) {
        return [...ops];
    }
    const known = new Set(ops.map((o) => o.id).filter((x) => !!x));
    const incoming = new Map();
    const edges = new Map();
    ops.forEach((op, idx) => {
        var _a, _b;
        const deps = ((_a = op.dependsOn) !== null && _a !== void 0 ? _a : []).filter((d) => {
            var _a;
            if (!known.has(d)) {
                // eslint-disable-next-line no-console
                console.warn(`[plugin-ui] "${(_a = op.id) !== null && _a !== void 0 ? _a : op.pluginId}" dependsOn "${d}" which no op declared in this phase; dropping the edge`);
                return false;
            }
            return true;
        });
        incoming.set(idx, deps.length);
        for (const d of deps) {
            const arr = (_b = edges.get(d)) !== null && _b !== void 0 ? _b : [];
            arr.push(idx);
            edges.set(d, arr);
        }
    });
    const ready = [];
    ops.forEach((_, idx) => {
        var _a;
        if (((_a = incoming.get(idx)) !== null && _a !== void 0 ? _a : 0) === 0) {
            ready.push(idx);
        }
    });
    const out = [];
    while (ready.length > 0) {
        const idx = ready.shift();
        const op = ops[idx];
        out.push(op);
        if (op.id) {
            for (const next of (_a = edges.get(op.id)) !== null && _a !== void 0 ? _a : []) {
                const left = ((_b = incoming.get(next)) !== null && _b !== void 0 ? _b : 0) - 1;
                incoming.set(next, left);
                if (left === 0) {
                    ready.push(next);
                }
            }
        }
    }
    if (out.length < ops.length) {
        // eslint-disable-next-line no-console
        console.warn(`[plugin-ui] dependency cycle in phase; running ${ops.length - out.length} ops in load order`);
        const seen = new Set(out);
        for (const op of ops) {
            if (!seen.has(op)) {
                out.push(op);
            }
        }
    }
    return out;
};
class RegionRouter {
    constructor(registry) {
        this.registry = registry;
        this.cache = new Map();
        this.cachedRegistrations = null;
        this.registry.onChange(() => {
            this.cache.clear();
            this.cachedRegistrations = null;
        });
    }
    get hasUiOps() {
        return this.registrations.length > 0;
    }
    get registrations() {
        var _a;
        if (this.cachedRegistrations) {
            return this.cachedRegistrations;
        }
        const out = [];
        for (const plugin of this.registry.list()) {
            for (const op of (_a = plugin.ui) !== null && _a !== void 0 ? _a : []) {
                out.push(Object.assign(Object.assign({}, op), { pluginId: plugin.id }));
            }
        }
        this.cachedRegistrations = out;
        return out;
    }
    resolveRegion(region) {
        // Every Region passes exactly one class.
        const cacheKey = `${region.id}|${region.classes[0]}`;
        const cached = this.cache.get(cacheKey);
        if (cached) {
            return cached;
        }
        const matched = this.registrations.filter((r) => r.match(region));
        const removes = matched.filter((o) => o.kind === "remove");
        const replaces = matched.filter((o) => o.kind === "replace");
        const wraps = matched.filter((o) => o.kind === "wrap");
        const augments = matched.filter((o) => o.kind === "augment");
        const transforms = matched.filter((o) => o.kind === "transform");
        if (replaces.length > 1) {
            const winner = replaces[replaces.length - 1];
            const losers = replaces.slice(0, -1).map((r) => r.pluginId);
            // eslint-disable-next-line no-console
            console.warn(`[plugin-ui] multiple replaces on region "${region.id}"; "${winner.pluginId}" wins, ignored: ${losers.join(", ")}`);
        }
        const ops = {
            remove: removes[0],
            replace: replaces[replaces.length - 1],
            wraps: topoSortByDependsOn(wraps),
            augmentBefore: topoSortByDependsOn(augments.filter((a) => a.slot === "before")),
            augmentAfter: topoSortByDependsOn(augments.filter((a) => a.slot === "after")),
            transforms: topoSortByDependsOn(transforms),
        };
        this.cache.set(cacheKey, ops);
        return ops;
    }
}
exports.RegionRouter = RegionRouter;
const composeRegion = (ops, children, ctx, region) => {
    if (ops.remove) {
        return null;
    }
    let node = ops.replace
        ? ops.replace.render(ctx, region)
        : children;
    // Apply wraps in registration order so the last applied is outermost.
    for (const w of ops.wraps) {
        node = w.render(node, ctx, region);
    }
    const before = ops.augmentBefore.map((a, i) => React.createElement(React.Fragment, { key: `b${i}` }, a.render(ctx, region)));
    const after = ops.augmentAfter.map((a, i) => React.createElement(React.Fragment, { key: `a${i}` }, a.render(ctx, region)));
    if (before.length > 0 || after.length > 0) {
        node = React.createElement(React.Fragment, null, ...before, node, ...after);
    }
    for (const t of ops.transforms) {
        node = t.render(node, ctx, region);
    }
    return node;
};
exports.composeRegion = composeRegion;
exports.regionRouter = new RegionRouter(registry_1.pluginRegistry);
